// components
import CommonActionModal from "../Common/CommonActionModal";

// icons
import TableViewIcon from "@mui/icons-material/TableView";
import LinkIcon from "@mui/icons-material/Link";
import RouteControlledEntityInner from "./RouteControlledEntityInner";


class RouteControlledEntityModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: LinkIcon,
            buttonColor: 'neutral',
            buttonVariant: 'soft',
            ready: true,
            flat: true,
        })
    }

    async beforeModalOpen(){
        return {
            modalLabel: 'Контролируемые сущности',
            modalIcon: TableViewIcon,
            mainComponent: RouteControlledEntityInner,
            mainComponentProps: {
                route: this.props.route,
            },
        }
    }
}

export default RouteControlledEntityModal
